import { PropsWithClassname } from "@/types"
import { cn, Image } from "@heroui/react"

export const Empty = ({ className, textClassName }: PropsWithClassname & { textClassName?: string }) => {
  return (
    <div className={cn("w-full text-center flex flex-col justify-center items-center",
      className
    )}>
      <Image
        src="/imgs/NotFound.svg"
        classNames={{
          wrapper: "flex-1 w-full",
          img: "w-[240px]"
        }}
      />
      <p className={cn("text-[13px] text-theme-primary/40", textClassName)}>No Data Available</p>
    </div>
  )
}